var _rect, _rect2, _rect3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelinex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 1.45,
    width: 16.1,
    height: 6.1,
    fill: "#233A80",
    stroke: "#233A80",
    strokeWidth: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 12.45,
    width: 16.1,
    height: 6.1,
    fill: "#233A80",
    stroke: "#233A80",
    strokeWidth: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 1,
    height: 20,
    fill: "#233A80"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 9.5,
    r: 1.5,
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelinex);
export default __webpack_public_path__ + "static/media/timelinex.4453537bf455af4579c4048aebb79cbe.svg";
export { ForwardRef as ReactComponent };